import { useCustomCursor } from "../../hooks/useCustomCursor";

const CustomCursor = () => {
  const { cursorRef, ringRef, isHoveringInteractive } = useCustomCursor();

  return (
    <>
      <div
        ref={cursorRef}
        className={`cursor ${isHoveringInteractive ? "is-hovering" : ""}`}
      />
      <div
        ref={ringRef}
        className={`cursor-ring ${isHoveringInteractive ? "is-hovering" : ""}`}
      />
    </>
  );
};

export default CustomCursor;
